import { render, staticRenderFns } from "./MajorManagePage.vue?vue&type=template&id=074634dc&"
import script from "./MajorManagePage.vue?vue&type=script&lang=js&"
export * from "./MajorManagePage.vue?vue&type=script&lang=js&"
import style0 from "./MajorManagePage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports